import { JobTitle } from '../../../domain/types';
import { PaginatedResult, PaginationParams, serializePagination } from '../../pagination';
import { API_AGENTS_SERP_PATH, getClient } from '../api';
import { SerpAgent } from '../dtos';
import { serializeParams } from '../utils/serializer';

export interface SerpAgentsProviderFilters {
  q?: string,
  active?: boolean,
  jobTitle?: JobTitle | JobTitle[],
  rookie?: boolean,
  areaManagerId?: number | number[],
}

export async function getSerpAgents(
  filters: SerpAgentsProviderFilters = {},
  pagination: PaginationParams = { size: 20 },
): Promise<PaginatedResult<SerpAgent>> {
  const client = await getClient();

  const { data } = await client.get(API_AGENTS_SERP_PATH, {
    params: {
      ...serializeParams(filters),
      ...serializePagination(pagination),
    },
  });

  return data;
}
